// extracted by mini-css-extract-plugin
export default {"container":"IntroductionPaper_container__Od7bo","textBlock":"IntroductionPaper_textBlock__LIy7U","buttonContainer":"IntroductionPaper_buttonContainer__cNbNx"};